import request from '@/utils/request'

// export function followPerson (data) {
//   return request({
//     url: '/v1/followed/insertFollowed',
//     method: 'post',
//     data,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   })
// }
// 获取浏览记录
export function getBrowseRecord (params) {
  return request({
    url: '/v1/post/selectMyBrowsingHistory',
    method: 'get',
    params
  })
}
export function fetchCategory (params) {
  return request({
    url: '/v1/category/queryCategory',
    method: 'get',
    params
  })
}
export function fetchPostCategoryList (params) {
  return request({
    url: '/v1/category/queryPostCategoryList',
    method: 'get',
    params
  })
}
export function upload (data) {
  return request({
    url: '/file/upload',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/articles-data' },
    data
  })
}

// 获取COS临时上传凭证
export function getCosCredential (params) {
  return request({
    url: '/v1/cos/credential',
    method: 'get',
    params
  })
}